module.exports = __webpack_public_path__ + "img/insights.7926d9ea.svg";